export function handleBlurInput(document: Document) {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
}
